// Admin - Dashbaord.

import React from 'react';
import Config from '../../lib/Config';
import Header from '../../lib-ui/admin/Header';
import UIString from '../../assets/content/UIString';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button } from '@mui/material';
import axios from 'axios';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavBar from '../../lib-ui/admin/NavBar';
import Alert from '@mui/material/Alert';
import Util from '../../lib/Util';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import { useNavigate } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import Chip from '@mui/material/Chip';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Block1Icon from '@mui/icons-material/Block';
import IOSSwitch from '../../lib-ui/common/IOSSwitch';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
//import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import Pagination from '@mui/material/Pagination';
import PagePanel from '../../lib-ui/common/PagePanel';
import SearchBar from '../../lib-ui/admin/SearchBar';
import { useSearchParams } from 'react-router-dom';
//기본 Line 차트
//https://react-chartjs-2.js.org/examples/line-chart
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import '../../assets/style/admin.css';





const lang = Util.get_lang();

export default () => {

    // const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const [navTitle, setNavTitle] = useState('');
    const [flagContent, setFlagContent] = useState('');
    const [flagToast, setFlagToast] = useState(false);
    const [toastMsg, setToastMsg] = useState();
    const [toastModeIcon, setToastModeIcon] = useState();
    const closeToast = () => { flagToast ? setFlagToast(false) : setFlagToast(true); }
    const showToast = (mode, msg) => {
        switch (mode) {
            case 'info': setToastModeIcon(<InfoIcon sx={{ fontSize: '32px', color: '#66ff66' }} />); break;
            case 'warning': setToastModeIcon(<WarningIcon sx={{ fontSize: '18px', color: '#6666ff' }} />); break;
        }

        setToastMsg(msg);
        setFlagToast(true);
    }
    const [keyword, setKeyword] = useState('');
    //const [listData, setListData] = useState({ current_page: 0, pages: [], prev_section: false, next_section: false });
    const [list, setList] = useState([]);
    const [detailPanel, setDetailPanel] = useState([]);

    //const [flagDataDetail, setFlagDataDetail] = useState('none');
    const [pagePanel, setPagePanel] = useState({ current_page: 0, pages: [], prev_section: false, next_section: false });
    //const [sessionDetailArray, setSessionDetailArray] = useState([]);

    //const [flagSessDetail, setFlagSessDetail] = useState([]);
    //const [profileImage, setProfileImage] = useState('/ko/api/v1/admin/user/app-session/profile_image/1/default.png');

    const [lightbox, setLightbox] = useState(false);
    const [lightboxImages, setLightboxImages] = useState([]);




    useEffect(() => {

        setNavTitle([UIString[lang]['NAV_CORP_SIGNOUT_REQUEST_LIST']]);
        load_list();

    }, []);






    function toggle_detail_panel(idx) {

        let t_array = [];

        for (let i = 0; i < detailPanel.length; i++) {

            let t_flag = detailPanel[i];

            if (i == idx) {
                if (t_flag == 'none') {
                    t_flag = '';
                    //     update_session_detail_flag(userList[idx].id, true);
                } else {
                    t_flag = 'none';
                    //     update_session_detail_flag(userList[idx].id, false);
                }
            }

            t_array[i] = t_flag;
        }

        setDetailPanel(t_array);
    }






    const load_page = (t) => {
        window.location.href = Config.BASE_URL + '/admin/mobile_app/list/' + t;
    }


    const start_search = (v) => {

        if (v.trim() == '') {
            alert('Please input search keyword!!');
            return;
        }

        if (!Util.no_special_chars(v)) {
            alert('No special chars!!');
            return;
        }

        let search_query = '';
        let src_query = v.split(' ');
        for (let i = 0; i < src_query.length; i++) {
            if (src_query[i].trim() != '') {
                if (search_query != '') { search_query = search_query + '+'; }
                search_query = search_query + src_query[i].trim();
            }
        }

        window.document.location.href = '/' + lang + '/admin/corp/signup/request/list/1?search=' + search_query;
    }


    const reset_search = () => {
        window.document.location.href = '/' + lang + '/admin/corp/signup/request/list/1';
    }





    function load_list() {

        let url = '/' + lang + '/api/v1/admin/corp/auth/signout/request/list/';
        let c_page = 1;
        let lines = 20;
        let saerch_keyword = '';
        let query_str = '';

        if (window.location.pathname.split('/').length > 6) {
            c_page = window.location.pathname.split('/')[7];
        }

        url = url + c_page;

        // Lines.
        if (
            searchParams.get('lines') != undefined &&
            searchParams.get('lines') != '' &&
            /([0-9]{1,3})/.test(searchParams.get('lines'))
        ) {
            lines = parseInt(searchParams.get('lines'));
            query_str = url + '?lines='
        }

        // Search keyword.
        if (searchParams.get('search') != undefined && searchParams.get('search') != '') {

            let t_search_str = searchParams.get('search').trim().replaceAll('+', ' ');
            setKeyword(t_search_str);

            if (query_str != '') {
                query_str = query_str + '&search=' + searchParams.get('search').trim();
            } else {
                query_str = query_str + '?search=' + searchParams.get('search').trim();
            }
        }

        // Request url.
        if (query_str != '') {
            url = url + query_str;
        }

        // Get data.
        let form = new FormData;
        Util.get(
            url,
            (data) => {

                let data_array = [];
                let data_detail_array = [];


                for (let i = 0; i < data.list.length; i++) {
                    let data_item = data.list[i];

                    switch (data_item.status) {
                        case 'WAITING': data_item.status_chip = <Chip label="WAITING" color="#ffcc00" size='small' sx={{ width: '100px', fontSize: '11px', backgroundColor: '#fff300', color: '#222222' }} />; break;
                        case 'COMPLETED': data_item.status_chip = <Chip label="COMPLETED" color="#ffcc00" size='small' sx={{ width: '100px', fontSize: '11px', backgroundColor: '#99ff00', color: '#222222' }} />; break;
                        case 'DELETED': data_item.status_chip = <Chip label="DELETED" color="#ffcc00" size='small' sx={{ width: '100px', fontSize: '11px', backgroundColor: '#222222', color: '#ffffff' }} />; break;
                        case 'EXPIRED': data_item.status_chip = <Chip label="EXPIRED" color="#ffcc00" size='small' sx={{ width: '100px', fontSize: '11px', backgroundColor: '#222222', color: '#ffffff' }} />; break;
                        case 'DECLINED': data_item.status_chip = <Chip label="DECLINED" color="#ffcc00" size='small' sx={{ width: '100px', fontSize: '11px', backgroundColor: '#a0a0a0', color: '#ffffff' }} />; break;
                        default: data_item.status_chip = <Chip label="UNKNOWN" color="#ffcc00" size='small' sx={{ width: '100px', fontSize: '11px', backgroundColor: '#afafaf', color: '#ffffff' }} />; break;
                    }

                    data_item.disp = 'none';

                    data_array.push(data_item);
                    data_detail_array.push('none');

                }


                setList(data_array);
                if (detailPanel.length == 0) { setDetailPanel(data_detail_array); }
                //setFlagSessDetail(sess_detail_array);

                setPagePanel({
                    prev_section: data.prev_section,
                    current_page: data.current_page,
                    next_section: data.next_section,
                    pages: data.pages
                });

                /*
                if (sess_array.length == 0) { setFlagContent('none'); } else { setFlagContent(''); }
                */
            },
            (err) => {
                if( err.error_code == 'LOGIN_REQUIRED' ){
                    alert(err.error);
                    document.location  = Util.page_url(lang,'/');
                }else{
                    showToast(err.error);
                }
            }
        );
    }





    const resend_signup_email = (t) => {
        const form = {
        }

        Util.post(
            Util.api_url(lang, '/admin/corp/auth/signup/request/email/send/' + t),
            form,
            (data) => {
                showToast('info', UIString[lang]['SIGNUP_EMAIL_SENT']);
                load_list();
            },
            (error) => {
                // document.location.href = '/admin/login';
                showToast(UIString[lang]['UPDATE_FAILED']);
            }
        );
    }



    const delete_signup_request = (t) => {

        const form = {
            name: 'status',
            value: 'DELETED'
        }

        Util.post(
            Util.api_url(lang, '/admin/corp/auth/signup/request/update/' + t),
            form,
            (data) => {
                showToast('info', UIString[lang]['UPDATED']);
                load_list();
            },
            (error) => {
                // document.location.href = '/admin/login';
                showToast(UIString[lang]['UPDATE_FAILED']);
            }
        );


    }

    function show_reg_image(img) {

        setLightboxImages([img]);
        setLightbox(true);

    }



    // const nav_links = [{ label: 'Home', url: '/'+lang+'/admin/dashboard' }, { label: 'Dashboard', url: '/Dashboard' }];

    return (
        <>
            <Header code={'corp'} />
            <div style={{ width: '1000px', height: '100%', minHeight: '600px', paddingTop: '60px', textAlign: 'center', backgroundColor: '#ffffff', margin: '0px auto' }}>

                <Stack className='page_title' direction={'col'}>
                    <NavBar text={navTitle} key={navTitle} />
                    <span className='nav_right_button' style={{ whiteSpace: 'nowrap' }} onClick={() => { window.history.back() }}>{UIString[lang]['ADD']}</span>
                </Stack>


                <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '38px', display: `${flagContent}` }}>
                    <SearchBar key={keyword} keyword={keyword} start_search={start_search} reset_search={reset_search} />
                    <TableContainer component={Paper} sx={{}}>
                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow sx={{ fontWeight: 'normal', fontSize: '13px', backgroundColor: '#f2f2f2' }}>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '80px' }} align='right'>Id</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '80px' }} align="left">Corp ID</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '180px' }} align="left">Corp Name</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', }} align="left">Corp Name (EN)</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '118px' }} align="left">Created</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '118px' }} align="left">Updated</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '80px' }} align="center">Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list.map((item, index) => <><TableRow sx={{ fontWeight: 'normal', fontSize: '13px', backgroundColor: '#ffffff', cursor: 'pointer', "&:hover": { backgroundColor: '#f8f8f8' } }} onClick={() => { Util.navigate(lang,'/admin/corp/signout/request/detail/'+item.id) /*toggle_detail_panel(index)*/ }}>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px' }} align='right'>{item.id}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', wordBreak: 'break-all', whiteSpace: 'nowrap', overflow: 'hidden' }} textOverflow="ellipsis" align="right">{item.corp_id}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} textOverflow="ellipsis" align="left">{item.corp_name}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', }} textOverflow="ellipsis" >{item.corp_en_name}</TableCell>
                                    <TableCell sx={{ maxWidth:'118px',fontWeight: 'normal', fontSize: '13px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} align="left">{item.created != null ? item.created + ' / ' + item.created_utc : 'N/A'}</TableCell>
                                    <TableCell sx={{ maxWidth:'118px',fontWeight: 'normal', fontSize: '13px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} align="left" textOverflow="ellipsis">{item.updated != null ? item.updated + ' / ' + item.updated_utc : '?'}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px' }} align="left">{item.status_chip}</TableCell></TableRow>
                                    <TableRow sx={{ display: `${detailPanel[index]}` }}><TableCell sx={{ backgroundColor: '#f8f8f8' }} colSpan={7}>
                                        <table style={{ width: '100%', bordeR: 'none', fontSize: '13px' }}>
                                            <tr>
                                                <td className='toggle_panel_label_td' style={{ width: '148px' }}>ID</td>
                                                <td className='toggle_panel_data_td'>{item.id}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Code</td>
                                                <td className='toggle_panel_data_td'>{item.code == null ? 'N/A' : item.code}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>country</td>
                                                <td className='toggle_panel_data_td'>{item.country}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Name</td>
                                                <td className='toggle_panel_data_td'>{item.name}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Name (EN)</td>
                                                <td className='toggle_panel_data_td'>{item.en_name}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>CEO's Name</td>
                                                <td className='toggle_panel_data_td'>{item.ceo_name}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>CEO's Name (EN)</td>
                                                <td className='toggle_panel_data_td'>{item.ceo_en_name}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Address</td>
                                                <td className='toggle_panel_data_td'>{item.address}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Address (EN)</td>
                                                <td className='toggle_panel_data_td'>{item.en_address}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Corp Type</td>
                                                <td className='toggle_panel_data_td'>{item.type == null ? 'N/A' : item.type}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Corp Type Desc</td>
                                                <td className='toggle_panel_data_td'>{item.type_desc == null ? 'N/A' : item.type_desc}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Reg Type</td>
                                                <td className='toggle_panel_data_td'>{item.reg_type}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Reg Type Desc</td>
                                                <td className='toggle_panel_data_td'>{item.reg_type_desc == null ? 'N/A' : item.reg_type_desc}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Reg ID</td>
                                                <td className='toggle_panel_data_td'>{item.reg_id}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Reg Image</td>
                                                <td className='toggle_panel_data_td'>{item.reg_image_file}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>&nbsp;&nbsp;</td>
                                                <td className='toggle_panel_data_td'><img style={{ backgroundColor: '#ffffff', width: '80px', height: '100px', cursor: 'pointer', objectFit: 'cover' }} onClick={() => { show_reg_image('/' + lang + '/api/v1/admin/corp/auth/signup/request/reg_image/' + item.reg_image_file) }} src={`${'/' + lang + '/api/v1/admin/corp/auth/signup/request/reg_image/' + item.reg_image_file}`} /></td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Logo Image</td>
                                                <td className='toggle_panel_data_td'>{item.logo_image_file == null ? 'N/A' : item.logo_image_file}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>&nbsp;&nbsp;</td>
                                                <td className='toggle_panel_data_td'><img style={{ backgroundColor: '#ffffff', width: '80px', height: '100px', cursor: 'pointer', objectFit: 'cover' }} onClick={() => { show_reg_image('/' + lang + '/api/v1/admin/corp/auth/signup/request/logo_image/' + item.logo_image_file) }} src={`${'/' + lang + '/api/v1/admin/corp/auth/signup/request/logo_image/' + item.logo_image_file}`} /></td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>DUNS number</td>
                                                <td className='toggle_panel_data_td'>{item.duns_number == null ? 'N/A' : item.duns_number}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Tel</td>
                                                <td className='toggle_panel_data_td'>{item.tel}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Admin Email</td>
                                                <td className='toggle_panel_data_td'>{item.admin_email}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Admin Name</td>
                                                <td className='toggle_panel_data_td'>{item.admin_name}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Admin Name (EN)</td>
                                                <td className='toggle_panel_data_td'>{item.admin_en_name}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Admin Mobile Number</td>
                                                <td className='toggle_panel_data_td'>{item.admin_mobile_number == null ? 'N/A' : item.admin_mobile_number}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Admin Dept</td>
                                                <td className='toggle_panel_data_td'>{item.admin_dept}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Admin Position</td>
                                                <td className='toggle_panel_data_td'>{item.admin_position}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Created IP</td>
                                                <td className='toggle_panel_data_td'>{item.created_ip}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Created</td>
                                                <td className='toggle_panel_data_td'>{item.created + ' / ' + item.created_utc}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Updated IP</td>
                                                <td className='toggle_panel_data_td'>{item.updated_ip == null ? 'N/A' : item.updated_ip}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Updated</td>
                                                <td className='toggle_panel_data_td'>{item.updated == null ? 'N/A' : item.updated + ' / ' + item.updated_utc}</td>
                                            </tr>
                                            <tr>
                                                <td className='toggle_panel_label_td'>Status</td>
                                                <td className='toggle_panel_data_td'>{item.status}</td>
                                            </tr>


                                            <tr>
                                                <td className='toggle_panel_label_td' style={{ height: '60px' }}>&nbsp;&nbsp;</td>
                                                <td style={{ textAlign: 'left', padding: '0px' }} >
                                                    <table style={{ width: '100%', height: '30px', borderWidth: '0px', border: 'none', borderCollapse: 'collapse' }}>
                                                        <tr>
                                                            <td style={{ textAlign: 'left', paddingLeft: '8px' }}>
                                                                {/*<Chip label="CONFIRM" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#99ff00', color: '#222222',cursor:'pointer' }} />&nbsp;&nbsp;&nbsp;&nbsp;*/}
                                                                <Chip label="SEND CONFIRM EMAIL" color="#ffcc00" size='small' sx={{ width: '180px', fontSize: '11px', backgroundColor: '#c2ff00', color: '#222222', cursor: 'pointer' }} onClick={() => { resend_signup_email(item.id) }} />
                                                            </td>
                                                            <td style={{ textAlign: 'right' }}>
                                                                <Chip label="DELETE" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#555555', color: '#ffffff', marginRight: '-3px', cursor: 'pointer' }} onClick={() => { delete_signup_request(item.id) }} />
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                        {/* 
                                        {"id":20,"country":"US","email":"dev06.choi@gmail.com","password":"$2b$10$Xld7w74DR43Le8wT7rMQgeOMx5HTyyOMIAeidiyGJ5mWij0Xh5yPa","name":"테스트","en_name":"Test User","year_of_birth":1990,"mobile_number":"01011111111","code":"780f721472c34471b96a419d9a86540cee9451095c8240c5bfc0b11931bad1da","created_tc":1730560743,"created_ip":"175.123.73.165","created":"2024-11-02T15:19:02.000Z","created_utc":"2024-11-02T15:19:02.000Z","updated_tc":1730561943,"updated_ip":"175.123.73.165","updated":"2024-11-02T15:39:03.000Z","updated_utc":"2024-11-02T15:39:03.000Z","status":"WAITING","status_chip":{"type":{"propTypes":{}},"key":null,"ref":null,"props":{"label":"WAITING","color":"#ffcc00","size":"small","sx":{"width":"80px","fontSize":"11px","backgroundColor":"#fff300","color":"#222222"}},"_owner":null,"_store":{}},"disp":"none"}
                                         */}
                                    </TableCell></TableRow>
                                </>)}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <br />
                    {<PagePanel
                        sx={{ display: `${flagContent}` }}
                        pages={pagePanel.pages}
                        current_page={pagePanel.current_page}
                        prev_section={pagePanel.prev_section}
                        next_section={pagePanel.next_section}
                        clicked={load_page}
                    />}
                </Paper>

                {flagContent == 'none' ? <Box sx={{ width: '100%', height: '600px', textAlign: 'center', fontSize: '13px' }}>
                    <WarningIcon style={{ fontSize: '80px', marginTop: '180px', marginBottom: '22px' }} /><br />
                    {UIString[lang]['NO_DATA']}
                </Box> : <></>}

                <div style={{ height: '600px' }}>&nbsp;&nbsp;</div>
                <Snackbar
                    sx={{}}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={flagToast}
                    onClose={closeToast}
                    autoHideDuration={1800}
                    key={'top' + 'center'}
                >
                    <SnackbarContent
                        sx={{
                            backgroundColor: '#fcfcfc',
                            color: '#222222',
                            minHeight: '60px',
                            fontSize: '13px',
                            display: "flex",
                            justifyContent: "space-between", // Space between text and icon
                            alignItems: "center",
                        }}

                        message={<Box display="flex" alignItems="center">
                            {toastModeIcon}&nbsp;&nbsp;
                            <span>{toastMsg}</span>
                        </Box>}
                        action={
                            <IconButton
                                size="small"
                                color="inherit"
                                onClick={() => console.log("Close clicked")}
                            >
                                <CloseIcon sx={{ cursor: 'pointer', fontSize: '18px', color: '#222222' }} onClick={() => { closeToast() }} />
                            </IconButton>}

                    />
                </Snackbar>


                {/*<Lightbox
                    open={lightbox}
                    close={() => setLightbox(false)}
                    slides={lightboxImages}
                />*/}



                {lightbox && (
                    <Lightbox

                        mainSrc={lightboxImages[0]}
                        //nextSrc={lightboxImages[(photoIndex + 1) % images.length]}
                        //prevSrc={lightboxImages[(photoIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => { setLightbox(false) }}
                    /*onMovePrevRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + images.length - 1) % images.length,
                        })
                    }
                    onMoveNextRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + 1) % images.length,
                        })
                    }*/
                    />
                )}

                <style>
                    {`
          .ReactModal__Overlay.ReactModal__Overlay--after-open {
            z-index: 1201 !important; /* Set above MUI AppBar */
          }
          .custom-lightbox .ril__outer {
            z-index: 1201 !important; /* Ensure lightbox container is above */
          }
        `}
                </style>




            </div>
        </>
    );

}